import apiSlice from '../../services/api/slice'
import { TAGS } from '../../constants/tags'

const clientsSlice = apiSlice.injectEndpoints({
  name: 'clients',
  endpoints: (builder) => ({
    getClients: builder.query({
      query: () => ({ url: `/v1/admin/clients`, method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.CLIENTS],
    }),
    getClient: builder.query({
      query: (clientId) => ({ url: `/v1/admin/clients/${clientId}`, method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.CLIENT],
    }),
    addClient: builder.mutation({
      query: (client) => ({ url: `/v1/admin/clients`, method: 'POST', body: client }),
      invalidatesTags: [TAGS.CLIENTS],
    }),
    updateClient: builder.mutation({
      query: (client) => ({ url: `/v1/admin/clients/${client.id}`, method: 'PUT', body: client }),
      invalidatesTags: [TAGS.CLIENTS, TAGS.CLIENT],
    }),
    deleteClient: builder.mutation({
      query: (clientId) => ({ url: `/v1/admin/clients/${clientId}`, method: 'DELETE' }),
      invalidatesTags: [TAGS.CLIENTS, TAGS.CLIENT],
    }),
    addProducer: builder.mutation({
      query: ({ clientId, producer }) => ({
        url: `/v1/admin/clients/${clientId}/producers`,
        method: 'POST',
        body: producer,
      }),
      invalidatesTags: [TAGS.CLIENTS, TAGS.CLIENT],
    }),
    updateProducer: builder.mutation({
      query: ({ clientId, producer }) => ({
        url: `/v1/admin/clients/${clientId}/producers/${producer.id}`,
        method: 'PUT',
        body: producer,
      }),
      invalidatesTags: [TAGS.CLIENTS, TAGS.CLIENT],
    }),
    deleteProducer: builder.mutation({
      query: ({ clientId, producerId }) => ({
        url: `/v1/admin/clients/${clientId}/producers/${producerId}`,
        method: 'DELETE',
        body: producerId,
      }),
      invalidatesTags: [TAGS.CLIENTS, TAGS.CLIENT],
    }),
  }),
})

export const {
  useGetClientQuery,
  useGetClientsQuery,
  useAddClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
  useAddProducerMutation,
  useUpdateProducerMutation,
  useDeleteProducerMutation,
} = clientsSlice

export default clientsSlice
